import { PageHeader } from "components/ui";
import React from 'react';
import { Grid, Typography, Box } from "@mui/material";
import CustomButton from 'components/buttonsComponent/StyledButton';
import NavigationButtons from 'helper/navigation/NavigationButtons';

const WhatArePriPrinciple = () => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <PageHeader
                        title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards"
                    />
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box className="gri-header">
                    <NavigationButtons imageKey="PRI Principle"  title={"PRI Principle Reporting"} activeStep={0} />
                </Box>
            </Grid>
            <Grid item xs={12}>
                <Box
                    sx={{
                        borderRadius: '8px',
                        padding: '24px',
                        top: '226px',
                        left: '75px',
                    }}
                >
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 700,
                            color: '#2E7D32',
                            mb: 3,
                            fontFamily: 'DM Sans',
                            fontSize: '40px',
                            lineHeight: '38px',
                        }}
                    >
                        The global standards for sustainability<br /> impacts
                    </Typography>

                    <Box sx={{ mb: 2 }}>
                        <Typography
                            component="h4"
                            sx={{
                                fontFamily: 'DM Sans',
                                fontWeight: 800,
                                fontSize: '20px',
                                lineHeight: '28px',
                                letterSpacing: '-2%',
                                color: '#4F4F4F',
                                mb: 1,
                            }}
                        >
                            What are the PRI Principles? — Brief introduction
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                fontFamily: 'DM Sans',
                                fontWeight: 400,
                                fontSize: '20px',
                                lineHeight: '28px',
                                letterSpacing: '-2%',
                                color: '#4F4F4F',
                                mb: 2,
                            }}
                        >
                            The Principles for Responsible Investment (PRI) are six voluntary, aspirational principles designed to help institutional investors integrate environmental, social, and governance (ESG) factors into their investment and ownership practices. Launched with support from the UNEP Finance Initiative and UN Global Compact, PRI is not a regulatory framework but a global commitment to sustainable finance and long-term value creation.
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                fontFamily: 'DM Sans',
                                fontWeight: 400,
                                fontSize: '20px',
                                lineHeight: '28px',
                                letterSpacing: '-2%',
                                color: '#4F4F4F',
                                mb: 2,
                            }}
                        >
                            Signatories commit to regular reporting through PRI’s Reporting Framework, demonstrating progress in ESG integration. Persistent non-compliance can result in loss of signatory status, making disclosure and accountability central to PRI participation.
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                fontFamily: 'DM Sans',
                                fontWeight: 400,
                                fontSize: '20px',
                                lineHeight: '28px',
                                letterSpacing: '-2%',
                                color: '#4F4F4F',
                                mb: 2,
                            }}
                        >
                            The six PRI Principles (with Technical Focus) are:
                        </Typography>
                        <Box component="ul" sx={{ pl: 4, mb: 2 }}>
                            <Typography
                                component="li"
                                sx={{
                                    fontFamily: 'DM Sans',
                                    fontWeight: 400,
                                    fontSize: '20px',
                                    lineHeight: '28px',
                                    letterSpacing: '-2%',
                                    color: '#4F4F4F',
                                }}
                            >
                                Integrate ESG in investment analysis — Incorporate ESG data, sector materiality, and climate scenarios into risk and valuation models.
                            </Typography>
                            <Typography
                                component="li"
                                sx={{
                                    fontFamily: 'DM Sans',
                                    fontWeight: 400,
                                    fontSize: '20px',
                                    lineHeight: '28px',
                                    letterSpacing: '-2%',
                                    color: '#4F4F4F',
                                }}
                            >
                                Exercise active ownership — Use proxy voting, shareholder resolutions, and direct engagement to influence ESG practices.
                            </Typography>
                            <Typography
                                component="li"
                                sx={{
                                    fontFamily: 'DM Sans',
                                    fontWeight: 400,
                                    fontSize: '20px',
                                    lineHeight: '28px',
                                    letterSpacing: '-2%',
                                    color: '#4F4F4F',
                                }}
                            >
                                Promote ESG disclosure — Push investees for aligned, standardized ESG disclosures (GRI, SASB, TCFD).
                            </Typography>
                            <Typography
                                component="li"
                                sx={{
                                    fontFamily: 'DM Sans',
                                    fontWeight: 400,
                                    fontSize: '20px',
                                    lineHeight: '28px',
                                    letterSpacing: '-2%',
                                    color: '#4F4F4F',
                                }}
                            >
                                Advance PRI principles across the industry — Collaborate with managers, advisors, and networks to expand ESG implementation.
                            </Typography>
                            <Typography
                                component="li"
                                sx={{
                                    fontFamily: 'DM Sans',
                                    fontWeight: 400,
                                    fontSize: '20px',
                                    lineHeight: '28px',
                                    letterSpacing: '-2%',
                                    color: '#4F4F4F',
                                }}
                            >
                                Collaborate for stronger ESG impact — Join investor coalitions, advocacy groups, and collective engagement initiatives.
                            </Typography>
                            <Typography
                                component="li"
                                sx={{
                                    fontFamily: 'DM Sans',
                                    fontWeight: 400,
                                    fontSize: '20px',
                                    lineHeight: '28px',
                                    letterSpacing: '-2%',
                                    color: '#4F4F4F',
                                }}
                            >
                                Report on implementation — Annually submit progress reports, ESG methodologies, and outcomes to PRI for benchmarking and assessment.
                            </Typography>
                        </Box>
                        <Typography
                            variant="body1"
                            sx={{
                                fontFamily: 'DM Sans',
                                fontWeight: 400,
                                fontSize: '20px',
                                lineHeight: '28px',
                                letterSpacing: '-2%',
                                color: '#4F4F4F',
                                mb: 2,
                            }}
                        >
                            PRI aligns with rising regulatory frameworks like SFDR, CSRD, and TCFD, and reinforces fiduciary duty by addressing material ESG risks and opportunities. Signatories gain access to ESG data, tools, and collaborative initiatives to strengthen sustainability performance and market leadership.
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <a
                        href="https://www.unpri.org/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none" }}
                    >
                        <CustomButton title="Access Full PRI Principles Documentation" />
                    </a>
                </Box>
            </Grid>
        </Grid>
    );
};

export default WhatArePriPrinciple;